import { pkceCodes } from './helpers/pkce';

const {
  REACT_APP_ENV_AWS_REGION,
  REACT_APP_ENV_AWS_USER_POOL_ID,
  REACT_APP_ENV_AWS_CLIENT_ID,
  REACT_APP_ENV_AWS_USER_POOL_DOMAIN,
  REACT_APP_ENV_ROOT_PATH,
} = process.env;

const awsconfig = {
  aws_project_region: REACT_APP_ENV_AWS_REGION,
  aws_cognito_region: REACT_APP_ENV_AWS_REGION,
  aws_user_pools_id: REACT_APP_ENV_AWS_USER_POOL_ID,
  aws_user_pools_web_client_id: REACT_APP_ENV_AWS_CLIENT_ID,
  redirect_uri: REACT_APP_ENV_ROOT_PATH,
  client_id: REACT_APP_ENV_AWS_CLIENT_ID,
  oauth: {
    domain: REACT_APP_ENV_AWS_USER_POOL_DOMAIN,
    scope: ['email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: REACT_APP_ENV_ROOT_PATH,
    redirectSignOut: REACT_APP_ENV_ROOT_PATH,
    responseType: 'code',
    codeChallengeMethod: 'S256',
    codeChallenge: pkceCodes?.codeChallenge,
  },
  federationTarget: 'COGNITO_USER_POOLS',
  aws_cognito_username_attributes: [],
  aws_cognito_social_providers: ['FACEBOOK', 'GOOGLE'],
  aws_cognito_signup_attributes: ['EMAIL'],
  aws_cognito_mfa_configuration: 'OFF',
  aws_cognito_password_protection_settings: {
    passwordPolicyMinLength: 8,
    passwordPolicyCharacters: [],
  },
  aws_cognito_verification_mechanisms: ['EMAIL'],
};

export default awsconfig;
